import { useState, useEffect, Fragment } from "react"
import { Link, useLocation } from "react-router-dom"

// 💡 1. 기존 메뉴 배열 (원본 그대로 유지)
const menus = [
  { label: "대시보드", path: "/admin" },
  { label: "상품관리", path: "/admin/products" },
  { label: "카테고리관리", path: "/admin/categories" },
  { label: "주문관리", path: "/admin/orders" },
  { label: "회원관리", path: "/admin/members" },
  { label: "화원관리", path: "/admin/partners" },
  { label: "리뷰관리", path: "/admin/reviews" },
  { label: "배너관리", path: "/admin/banners" },
  { label: "설정", path: "/admin/settings" },
  { label: "전국 화원 지도", path: "/admin/partners/map" },
]

// 💡 2. 고객센터 하위 메뉴 배열 (공지사항 활성화)
const csMenus = [
  { label: "1:1 문의 관리", path: "/admin/cs/inquiries" },
  { label: "FAQ 관리 (준비중)", path: "/admin/cs/faq", disabled: true },
  { label: "공지사항 관리", path: "/admin/cs/notices" }, // 💡 disabled 제거 및 라벨 수정
]

export default function AdminSidebar() {
  const location = useLocation()

  // 고객센터 메뉴 열림/닫힘 상태 관리
  const [isCsOpen, setIsCsOpen] = useState(false)

  // 고객센터 관련 페이지 진입 시 자동으로 메뉴 열기
  useEffect(() => {
    if (location.pathname.startsWith("/admin/cs")) {
      setIsCsOpen(true)
    }
  }, [location.pathname])

  return (
    <aside className="w-full rounded-[28px] border border-slate-200 bg-white p-4 shadow-sm lg:w-[260px]">
      <div className="mb-4 px-3 py-2">
        <p className="text-lg font-bold text-slate-900">MG퀵플라워 Admin</p>
        <p className="mt-1 text-xs text-slate-500">쇼핑몰 운영 관리자</p>
      </div>

      <nav className="space-y-1">
        {menus.map((menu) => {
          const active =
            menu.path === "/admin"
              ? location.pathname === "/admin"
              : location.pathname.startsWith(menu.path)

          // '배너관리'일 경우, 배너관리를 먼저 그리고 그 밑에 고객센터 아코디언을 바로 이어 붙입니다.
          if (menu.label === "배너관리") {
            return (
              <Fragment key={menu.path}>
                <Link
                  to={menu.path}
                  className={`block rounded-xl px-4 py-3 text-sm font-medium transition ${
                    active ? "bg-slate-900 text-white" : "text-slate-700 hover:bg-slate-100"
                  }`}
                >
                  {menu.label}
                </Link>

                {/* 🔽 고객센터 관리 메뉴 영역 (배너관리 바로 아래 위치) */}
                <div>
                  <button
                    onClick={() => setIsCsOpen(!isCsOpen)}
                    className="flex w-full items-center justify-between rounded-xl px-4 py-3 text-sm font-medium text-slate-700 hover:bg-slate-100 transition"
                  >
                    <span>고객센터 관리</span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      className={`h-4 w-4 text-slate-400 transition-transform duration-300 ${
                        isCsOpen ? "rotate-180" : ""
                      }`}
                      fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}
                    >
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                    </svg>
                  </button>

                  {/* 하위 메뉴 영역 (애니메이션) */}
                  <div
                    className={`overflow-hidden transition-all duration-300 ease-in-out ${
                      isCsOpen ? "max-h-[300px] opacity-100 mt-1 mb-1" : "max-h-0 opacity-0"
                    }`}
                  >
                    <div className="space-y-1 border-l-2 border-slate-100 ml-6 pl-3 py-1 my-1">
                      {csMenus.map((csMenu) => {
                        if (csMenu.disabled) {
                          return (
                            <span
                              key={csMenu.path}
                              className="block rounded-xl px-3 py-2 text-[13px] font-medium text-slate-400 cursor-not-allowed"
                            >
                              {csMenu.label}
                            </span>
                          )
                        }

                        const isCsActive = location.pathname.startsWith(csMenu.path)

                        return (
                          <Link
                            key={csMenu.path}
                            to={csMenu.path}
                            className={`block rounded-xl px-3 py-2 text-[13px] font-medium transition-colors ${
                              isCsActive
                                ? "bg-slate-900 text-white"
                                : "text-slate-600 hover:bg-slate-100 hover:text-slate-900"
                            }`}
                          >
                            {csMenu.label}
                          </Link>
                        )
                      })}
                    </div>
                  </div>
                </div>
              </Fragment>
            )
          }

          // '배너관리'가 아닌 나머지 메뉴들은 평소처럼 렌더링합니다.
          return (
            <Link
              key={menu.path}
              to={menu.path}
              className={`block rounded-xl px-4 py-3 text-sm font-medium transition ${
                active ? "bg-slate-900 text-white" : "text-slate-700 hover:bg-slate-100"
              }`}
            >
              {menu.label}
            </Link>
          )
        })}
      </nav>
    </aside>
  )
}